import { observable, action } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { TaskNotificationsStore } from 'application/dashboard/stores';
import { TaskCommentService } from 'application/schedule/services';
// import { TaskCommentNotificationService } from 'application/dashboard/services';

export default class GlobalTaskNotificationsStore extends BaseViewStore {
    @observable accessor notificationMenuOpen = false;
    @observable accessor numOfNotifications = 0;

    _interval = 30 * 1000; // 30 sec

    constructor(rootStore) {
        super(rootStore);

        this.taskCommentService = new TaskCommentService(rootStore.application.baasic.apiClient);
        // this.taskCommentNotificationService = new TaskCommentNotificationService(rootStore.application.baasic.apiClient); 

        this.taskNotificationsStore = new TaskNotificationsStore(rootStore,{
            fetchFunc: async () => {
                return await this.taskCommentService.find({
                    isRead: false, 
                    receiverUserId: rootStore.userStore.user.id, 
                    embed: 'Author,FacilityScheduleDate,TaskCommentNotifications',
                    rpp:300
                });
            },          
        });

        this.fetch([
            this.initialize()
        ]);
    }

    @action.bound
    async initialize() {
        try {
            this.countNotifications();
            
            if (this.countNotificationsInterval) {
                clearInterval(this.countNotificationsInterval);
            }
            this.countNotificationsInterval = setInterval(
                this.countNotifications,
                this._interval
            );
        } catch (err) {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred while trying to refresh counter",
                err
            );
        }
    }

    destroy() {
        if (this.countNotificationsInterval) {
            clearInterval(this.countNotificationsInterval);
        }
        super.destroy();
    }

    @action.bound
    async countNotifications() {
        // const response = await this.taskCommentNotificationService.count(this.rootStore.userStore.user.id);
        this.numOfNotifications = 0;//response.data;
    }

    @action.bound
    async tasksFetch() {
        await this.taskNotificationsStore.callFunc();
    }

    @action.bound
    async toggleNotificationMenu() {
        if(!this.notificationMenuOpen){
            await this.countNotifications();
            this.tasksFetch();
        }
        this.notificationMenuOpen = !this.notificationMenuOpen;
    }

    @action.bound
    setNotificationMenu(visible) {
        this.notificationMenuOpen = visible;
    }
}
